import { SnackbarProvider } from './component';

export * from './component';

export default SnackbarProvider;
